__turbopack_context__.v({
  "dark": "LoadingSkeleton-module__aw8Hbq__dark",
  "shine": "LoadingSkeleton-module__aw8Hbq__shine",
  "skeleton": "LoadingSkeleton-module__aw8Hbq__skeleton",
});
